export default __webpack_public_path__ + "static/media/ilustracao-logo-bom-consorcio.8bc94f0d.svg";